import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Observable } from "rxjs";
import { ApiService } from "./api.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AdminProfileDataService {
  profile: any = {};
  abbrivationsData: any = {};

  constructor(private http: HttpClient, private api: ApiService) {}

  createEvent(data: any) {
    return this.api.POST_BR(environment.CANDIDATE_APIS.createEvent, data);
  }
  getAllEvents(data: any) {
    return this.api.GET_BR(environment.CANDIDATE_APIS.getAllEvents, data);
  }
  updateEvent(data: any) {
    return this.api.POST_BR(environment.CANDIDATE_APIS.updateEvent, data);
  }
  deleteEvent(data: any) {
    return this.api.POST_BR(environment.CANDIDATE_APIS.deleteEvent, data);
  }

  // Plans apis
  createPlans(data: any): Observable<any> {
    return this.api.POST_BR(environment.ADMIN_APIS.createPlans, data);
  }
  getAllPlans(data: any): Observable<any> {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllPlans, data);
  }
  updatePlan(data: any): Observable<any> {
    return this.api.POST_BR(environment.ADMIN_APIS.updatePlan, data);
  }

  deletePlan(data: any): Observable<any> {
    return this.api.POST_BR(environment.ADMIN_APIS.deletePlan, data);
  }
  
  changePassword(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.changePassword, data);
  }

  // plans module
  createAppModuleMaster(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createAppModuleMaster, data);
  }
  updateAppModuleMaster(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateAppModuleMaster, data);
  }
  deleteAppModuleMaster(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteAppModuleMaster, data);
  }
  getAppModuleMaster(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAppModuleMaster, data);
  }

  //Job DB Plans
  
  createDbPlans(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createDbPlans, data);
  }

  getDbPlans(data: any) {

    return this.api.GET_BR(environment.ADMIN_APIS.getDbPlans, data);
  }
  updateDbPlan(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateDbPlan, data);
  }
  deleteDbPlan(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteDbPlan, data);
  }

  createAdvertPlans(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createAdvertPlans, data);
  }

  getAllAdvertPlans(data: any) {

    return this.api.GET_BR(environment.ADMIN_APIS.getAllAdvertPlans, data);
  }
  updateAdvertPlan(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateAdvertPlan, data);
  }
  deleteAdvertPlan(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteAdvertPlan, data);
  }
  createPlansLabel(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createPlansLabel, data);
  }

  getAllPlansLabel(data: any) {

    return this.api.GET_BR(environment.ADMIN_APIS.getAllPlansLabel, data);
  }
  updatePlansLabel(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updatePlansLabel, data);
  }
  deletePlansLabel(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deletePlansLabel, data);
  }
   getCandidateQuestionPaperByExamCode(data: any) {
    return this.api.POST_BR(environment.CANDIDATE_APIS.getCandidateQuestionPaperByExamCode,data);
  }
  validateUserOnlineExam(data: any) {
    return this.api.POST_BR(environment.CANDIDATE_APIS.validateUserOnlineExam,data);
  }
  
  createResumeBuilderPlans(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createResumeBuilderPlans, data);
  }

  getAllResumeBuilderPlans(data: any) {

    return this.api.GET_BR(environment.ADMIN_APIS.getAllResumeBuilderPlans, data);
  }
  updateResumeBuilderPlans(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateResumeBuilderPlans, data);
  }
  updateResumeBuilderPlanImage(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateResumeBuilderPlanImage, data);
  }
  deleteResumeBuilderPlans(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteResumeBuilderPlans, data);
  }

  createHrmsPlans(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createHrmsPlans, data);
  }
  updateHrmsPlans(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateHrmsPlans, data);
  }
  getHrmsPlans(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getHrmsPlans, data);
  }
  deleteHrmsPlans(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteHrmsPlans, data);
  }
  

  
}
